module.exports = __webpack_public_path__ + "images/Rectangle 202 (1).svg";